import { ms } from 'fuse_common/utils/data/ms'
import { makeLocalStorageHandler } from 'fuse_common/utils/storage/local-storage'

export const appThemeLocalStorage = makeLocalStorageHandler<'light' | 'dark' | null>('theme', null)
export const onboardingMapPositionLocalStorage = makeLocalStorageHandler<{
  lat: number
  long: number
  addressLabel: string | null
} | null>('fuse.onboarding-map-position', null, ms(2, 'days'))
export const preonboardingPostcodeLocalStorage = makeLocalStorageHandler<string | null>(
  'fuse.preonboarding-postcode',
  null,
  ms(2, 'days'),
)
export const supportChatOpenedLocalStorage = makeLocalStorageHandler<'opened' | null>(
  'fuse.support-chat-opened',
  null,
  ms(2, 'days'),
)
export const storeCartLocalStorage = makeLocalStorageHandler<{
  products: { productId: string; quantity: number; customizations: string[] }[]
}>('fuse.store-cart', { products: [] }, ms(1, 'days'))
export const cameraAccessLocalStorage = makeLocalStorageHandler<
  {
    deviceId: string
    status: 'granted' | 'denied'
  }[]
>('fuse-camera-access', [])
